export default "__VITE_ASSET__e02c2715__"